export default __webpack_public_path__ + "static/douglas-c067b5076a3097328948e35bbd403ab3.jpeg";